<template>
  <div>
    <div v-show="conShow">
      <div>
        <headMenu @showApply="showApply"></headMenu>
      </div>
      <div>
        <div class="con1 con-imgSize">
          <div style="padding-top: 10%;">
            <img style="width: 65%" src="../assets/home-x.png" alt="">
<!--            <img style="width: 4%;margin-right: 1%" v-for="i in new Array(7)" src="../assets/home-xing.png" alt="">-->
<!--            <span class="con-text">七星格服务</span>-->
          </div>
          <div class="con1-title">
            <span style="color: #2D2D2D">论文检测</span>
            <span style="color: #DC4900">首选</span>
            <span style="color: #005CE5">格子达</span>
          </div>
          <div>
            <img style="width: 75%;margin-top: 7%" src="../assets/home-i.png" alt="">
          </div>
<!--          <div style="display: flex;height: 100px;">-->
<!--            <div class="setImg">助学</div>-->
<!--            <div class="setImg">助管</div>-->
<!--            <div class="setImg">助研</div>-->
<!--          </div>-->
          <div class="home-bigImg">
            <img style="width: 100%;" src="../assets/home-1-1.png" alt="">
          </div>
        </div>
        <div class="con2 con-imgSize">
          <div class="con-title">产品服务</div>
          <div>
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="slide1">
                    <div style="width: 100%">
                      <div class="cp-font"><span style="color: #005CE5">论文查重</span>检测系统</div>
                      <div class="cp-text">
                        千亿级比对文献资源索引库+EB级的在线和存档网页，查得更全，将知识图谱和元数据嵌入BERT，自研文本语义级识别模型加模糊指纹比对算法，查得更准，技术监督和侦测抄袭行为意愿和能力，辅助学校判定论文原创度。
                      </div>
                      <div>
                        <img width="90%" src="../assets/chachong.gif" alt="">
                      </div>
                      <div>
                        <div @click="lookDetails(1)" class="cp-btn">了解详情</div>
                      </div>
                      <div style="height: 20px"></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="slide1">
                    <div class="cp-font"><span style="color: #005CE5">论文格式</span>检测系统</div>
                    <div class="cp-text" style="width: 90%;white-space: initial">
                      基于《学位论文编写规则》，支持高校敏捷定制不同学科和专业的论文模板，提供格式检测简版报告和详细的格式批注报告。
                    </div>
                    <div>
                      <img width="90%" src="../assets/geshi.png" alt="">
                    </div>
                    <div>
                      <div @click="lookDetails(2)" class="cp-btn">了解详情</div>
                    </div>
                    <div style="height: 20px"></div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="slide1">
                    <div class="cp-font"><span style="color: #005CE5">毕设（论文）</span>管理系统</div>
                    <div class="cp-text">
                      全流程覆盖毕设全过程管理，各环节过程数据真实可靠，告别复杂教程和操作，助力导师高效审核，体验清晰悦目的管理报表及简易任务台，时刻精准掌控工作进展。支持归档材料一键生成，智能查漏补缺。
                    </div>
                    <div>
                      <img width="90%" src="../assets/bishe.png" alt="">
                    </div>
                    <div>
                      <div @click="lookDetails(3)" class="cp-btn">了解详情</div>
                    </div>
                    <div style="height: 20px"></div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="slide1">
                    <div class="cp-font"><span style="color: #005CE5">论文抽检</span>系统</div>
                    <div class="cp-text">
                      严格遵循相关政策，遵照教育部学位中心抽检平台技术参数运行，拥有超30万评审专家，涵盖本省、跨省、同级别、同学科、同专业。产品通过三级等保要求，符合CMMI3规范，业内高精准AI遴选评阅，高效、可靠、低成本，七星格服务为学校评审工作提供完备支撑保障。
                    </div>
                    <div>
                      <img width="90%" src="../assets/choujian.png" alt="">
                    </div>
                    <div>
                      <div @click="lookDetails(4)" class="cp-btn">了解详情</div>
                    </div>
                    <div style="height: 20px"></div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <div class="con3 con-imgSize">
          <div class="con-title" style="color: #FFFFFF">产品优势</div>
          <div style="display: flex">
            <div style="width: 33%">
              <div class="con3-title">10年+</div>
              <div class="con4-value">沉淀时间</div>
            </div>
            <div style="width: 33%">
              <div class="con3-title">2000w+</div>
              <div class="con4-value">服务用户</div>
            </div>
            <div style="width: 33%">
              <div class="con3-title">1200+</div>
              <div class="con4-value">合作机构</div>
            </div>
          </div>
          <div style="margin-top: 5%">
            <img style="width: 90%" src="../assets/home-ys.png" alt="">
          </div>
<!--          <div style="position: relative;margin: 5%">-->
<!--            <div style="display: flex">-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">70亿+</div>-->
<!--                  <div class="con3-text">学术期刊库索引库</div>-->
<!--                </div>-->
<!--                <img style="width: 100%" src="../assets/con3-img1.png" alt="">-->
<!--              </div>-->
<!--              <div style="margin: 10px;">-->
<!--                  <div class="con-postion">-->
<!--                    <div class="con3-num">13亿+</div>-->
<!--                    <div class="con3-text">学位论文库索引库</div>-->
<!--                  </div>-->
<!--                <img style="width: 100%" src="../assets/con3-img1.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="display: flex">-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">千亿级</div>-->
<!--                  <div class="con3-text">互联网资源库索引库</div>-->
<!--                </div><img style="width: 100%" src="../assets/con3-img1.png" alt=""></div>-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">近亿+</div>-->
<!--                  <div class="con3-text">本科论文索引库</div>-->
<!--                </div><img style="width: 100%" src="../assets/con3-img1.png" alt=""></div>-->
<!--            </div>-->
<!--            <div style="display: flex">-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">7000万+</div>-->
<!--                  <div class="con3-text">会议论文索引库</div>-->
<!--                </div><img style="width: 100%" src="../assets/con3-img1.png" alt=""></div>-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">数亿+</div>-->
<!--                  <div class="con3-text">专业公识索引库</div>-->
<!--                </div><img style="width: 100%" src="../assets/con3-img1.png" alt=""></div>-->
<!--            </div>-->
<!--            <div style="display: flex">-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">近亿+</div>-->
<!--                  <div class="con3-text">专利索引库</div>-->
<!--                </div><img style="width: 100%" src="../assets/con3-img1.png" alt=""></div>-->
<!--              <div style="margin: 10px;">-->
<!--                <div class="con-postion">-->
<!--                  <div class="con3-num">9000万+</div>-->
<!--                  <div class="con3-text">报纸资源索引库</div>-->
<!--                </div><img style="width: 100%" src="../assets/con3-img1.png" alt=""></div>-->
<!--            </div>-->
<!--            <div style="margin: 10px;">-->
<!--              <div class="con-postion">-->
<!--                <div class="con3-num">近亿+</div>-->
<!--                <div class="con3-text">格子达多元索引库（公式、源代码、表格等）</div>-->
<!--              </div>-->
<!--              <img style="width: 100%" src="../assets/con3-img2.png" alt="">-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="con4 con-imgSize">
          <div class="con-title">社会好评</div>
          <div class="swiper-container1">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/zn.png" alt="">
                  </div>
                  <div class="hp-text">
                    我校使用格子达论文查重服务已有7年，格子达的比对索引库非常丰富，算法比较独特，查重准确率非常高，帮助发现、预防学生学术不端行为，是非常好用高效的查重检测产品。
                  </div>
                  <div class="schoo-teacher">
                    ——中南大学  主任 教授  李老师
                  </div>
                  <div class="hp-num">
                    检测292848次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/zgdz.png" alt="">
                  </div>
                  <div class="hp-text">
                    每年的毕设论文中，经常出现学生抄袭同届或往届论文情况，这是指导老师最难发现的问题之一，格子达毕设管理系统提供了学校自建论文库功能，帮学校建立论文库，很好的解决了该问题，体验上非常好。
                  </div>
                  <div class="schoo-teacher">
                    ——中国地质大学（武汉）本科生院   章老师
                  </div>
                  <div class="hp-num">
                    检测68374次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/hzsf.png" alt="">
                  </div>
                  <div class="hp-text">
                    学校院系多、专业多，每年统计毕设进度都是一项工作量巨大且繁琐的事，无形中加重了老师工作负担，自从2021年开始使用格子达毕设管理系统，从学校到学生，所有环节都通过系统进行有效管理，这些问题都得到有效解决。
                  </div>
                  <div class="schoo-teacher">
                    ——华中师范大学 本科生院   苏老师
                  </div>
                  <div class="hp-num">
                    检测128562次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/hn.png" alt="">
                  </div>
                  <div class="hp-text">
                    2022年8月本科抽检提交信息表和学生论文时，因时间紧、要求严格，大家搞了好几个通宵。后来听说格子达毕设系统支持一键格式化导出本科抽检材料，解决了棘手问题，期待系统可以做出更多帮大家解压的好功能！
                  </div>
                  <div class="schoo-teacher">
                    ——河南大学  教务处副处长  朱老师
                  </div>
                  <div class="hp-num">
                    检测524866次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/hnny.png" alt="">
                  </div>
                  <div class="hp-text">
                    在过去，学生格式不规范问题为毕业生论文撰写的主要痛点， 格式调整占用导师大量时间，也无法准确判断格式问题位置。尝试使用格子达格式检测系统后，快速找出格式问题并提供校正思路，问题得到完美解决。
                  </div>
                  <div class="schoo-teacher">
                    ——湖南农业大学   教务处副处长 副教授  娄老师
                  </div>
                  <div class="hp-num">
                    检测218652次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/hnlg.png" alt="">
                  </div>
                  <div class="hp-text">
                    格子达论文检测系统操作便捷、检测效率和准确率高，同时论文数据安全性好，论文数据不会被泄露。格子达毕设管理系统，有学生、指导教师、院系管理、学校管理，不同角色分配，实现毕业设计所有环节过程性有效管理，可实现无纸化存档。
                  </div>
                  <div class="schoo-teacher">
                    ——河南理工大学  吴老师
                  </div>
                  <div class="hp-num">
                    检测321863次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/hnsf.png" alt="">
                  </div>
                  <div class="hp-text">
                    毕业时候，经常出现部分导师联系不到毕业生的情况，格子达毕设管理系统通过跨平台一键催促功能，帮我们实现了学生按期完成毕业论文工作，我们用起来越来越顺手啦！
                  </div>
                  <div class="schoo-teacher">
                    ——河南师范大学  教务处副处长   崔老师
                  </div>
                  <div class="hp-num">
                    检测135367次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/hnsw.jpg" alt="">
                  </div>
                  <div class="hp-text">
                    自从学校引入格子达毕设管理系统，解决了师生论文各环节管理上存在的诸多问题，老师可以通过线上了解每位学生论文进度情况，学生能直观了解论文进展与反馈，为老师减少了大量的工作量，提高效率。
                  </div>
                  <div class="schoo-teacher">
                    ——湖南涉外经济学院 教学副校长 教授  高老师
                  </div>
                  <div class="hp-num">
                    检测341458次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide2">
                  <div>
                    <img style="width: 100%" src="../assets/school/whwl.png" alt="">
                  </div>
                  <div class="hp-text">
                    为落实和检测学生毕业论文学术规范工作，格子达给学校提供了专业化，标准化，统一化高水平软件平台。
                    通过使用格子达毕业论文检测系统，规范了学校毕业论文过程管理，方便了老师对学生论文过程指导，统一了论文质量标准。
                    利用系统平台方便了后期毕业论文数据上报及评估资料整理。
                  </div>
                  <div class="schoo-teacher">
                    ——武汉文理学院  教务处   李老师
                  </div>
                  <div class="hp-num">
                    检测124285次
                  </div>
                  <div class="hp-check">
                    截至2022年，累计检测次数
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination1"></div>
          </div>
        </div>
        <div class="con5 con-imgSize" style="margin-top: -1px;">
          <div class="con-title">1200+合作机构</div>
          <div class="foot-schoolImg">
            <img style="width: 100%;height: 100%" src="../assets/schoolImg1.png" alt="">
          </div>
          <div style="display: flex;margin-top: 5%;">
            <div class="leftSty">
              <div><img style="width: 80%;" src="../assets/QRcode.jpg" alt=""></div>
              <div class="qrSty">扫码关注公众号</div>
            </div>
            <div class="rightSty">
              <div><img style="width: 80%" src="../assets/foot-logo1.png" alt=""></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <applyDetails ref="apply" @returnPage="returnPage"></applyDetails>
    <productDetails ref="pro" @returnPage="returnPage"></productDetails>
  </div>
</template>

<script>
import headMenu from "@/head/headMenu.vue";
import applyDetails from "@/head/components/applyDetails.vue";
import productDetails from "@/views/components/productDetails.vue";

import 'swiper/css/swiper.css';
import Swiper from 'swiper';

export default {
  name: "homePage",
  components: {
    headMenu,
    applyDetails,
    productDetails,
  },
  data() {
    return {
      conShow: true
    }
  },
  mounted() {
    window.scroll(0, 0);
    this.conShow = true
    new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    new Swiper('.swiper-container1', {
      direction: 'horizontal',
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination1',
        clickable: true,
      },
    });
  },
  methods: {
    showApply() {
      this.conShow = false
      this.$refs.apply.init()
    },
    returnPage(){
      this.conShow = true
    },
    lookDetails(type){
      this.conShow = false
      this.$refs.pro.init(type)
    },
  }
}
</script>

<style scoped>
.xqlj{
    width: 150px;
    height: 40px;
    border: 2px solid #2E3546;
    margin-bottom: 10px;
    margin-right: 20px;
    border-radius: 20px;
    color: #2E3546;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    line-height: 40px;
}
.cp-btn{
    width: 150px;
    height: 40px;
    background: #005CE5;
    border-radius: 20px;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    margin-top: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 40px;
}
.cp-btn-hide{
    width: 150px;
    height: 40px;
    border-radius: 20px;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    margin-top: 15px;
    font-size: 16px;
    color: white;
    font-weight: bold;
    line-height: 40px;
}
.cp-btn1{
    width: 150px;
    height: 40px;
    border-radius: 20px;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    margin-top: 15px;
    font-size: 16px;
    font-weight: bold;
    color: black;
    border: 1px solid #2E3546;
    line-height: 40px;
}
.cp-font{
    font-size: 18px;
    font-weight: bold;
    height: 30px;
    padding-top: 25px;
}
.cp-text{
    font-size: 15px;
    font-weight: 400;
    color: #2E3546;
    height: 160px;
    margin: 20px;
    line-height: 26px;
    white-space: initial;
    text-align: left;
}
.hp-text{
    font-size: 15px;
    font-weight: 400;
    color: #2E3546;
    height: 120px;
    margin: 20px;
    margin-top: 0px;
    margin-bottom: 30px;
    line-height: 26px;
    white-space: initial;
    text-align: left;
}
.hp-num{
    font-size: 24px;
    font-weight: bold;
    color: #2E3546;
    padding: 20px 0 10px 0;
}
.hp-check{
    font-size: 13px;
    font-weight: 400;
    color: #7D8291;
    line-height: 0px;
}
.schoo-teacher{
    font-size: 13px;
    font-weight: 400;
    text-align: right;
    padding-right: 30px;
    padding-top: 30px;
}
.con-postion{
    position: absolute;
    /*margin-top: 20px;*/
    /*margin-left: 48px;*/
    margin: 8%;
    margin-top: 3%;
}
.con3-num{
    font-size: 20px;
    font-weight: bold;
    color: #00FFFC;
    margin-bottom: 5px
}
.con3-text{
    font-size: 12px;
    font-weight: 400;
    color: #00FFFC;
}
.con3-title{
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;
}
.con4-value{
    font-size: 12px;
    font-weight: 400;
    color: #CCCCCC;
}
.con-content{
    width: 93%;
    height: 500px;
    background: #FFFFFF;
    position: relative;
    margin: 14px;
    border-radius: 20px;
    white-space: nowrap;
    display: inline-block;
    box-shadow: 0px 0px 16px 4px rgba(0,0,0,0.1);
}
.con-content-hp{
    width: 93%;
    height: 500px;
    background: #FFFFFF;
    position: relative;
    margin: 14px;
    white-space: nowrap;
    display: inline-block;
    box-shadow: 0px 0px 16px 4px rgba(0,0,0,0.1);
}
.scroll{
    text-align: center;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
}
.scroll::-webkit-scrollbar {display:none}
.con-title{
    color: #2E3546;
    font-size: 27px;
    font-weight: bold;
    padding: 14px;
}
.setImg{
    background: url("../assets/home-icon.png") no-repeat;
    background-size: 100%;
    min-height: 100px;
    min-width: 70px;
    margin: 28px;
    color: #0445E0;
    font-size: 21px;
    line-height: 0px;
}
.con1{
    background: url("../assets/home-1.jpg") no-repeat;
    background-size: 100%;
    width: 100%;
}
.con2{
    background: url("../assets/home-2.jpg") no-repeat;
}
.con3{
    background: url("../assets/home-3.jpg") no-repeat;
}
.con4{
    background: url("../assets/home-4.jpg") no-repeat;
}
.con5{
    background: url("../assets/home-5.jpg") no-repeat;
}
.con-imgSize{
    background-size: 100% 100%;
    width: 100%;
    padding-bottom: 30px;
}
.qrSty{
    font-size: 14px;
    font-weight: 400;
    color: #2E3546;
    font-weight: 400;
}
.footSty{
    font-size: 18px;
    font-weight: 400;
    color: #2E3546;
}
.foot-schoolImg{
    margin: 15px;
}
.leftSty{
    width: 200px;
    height: 200px;
}
.rightSty{
    width: 288px;
    height: 112px;
    margin-top: 5%;
    margin-right: 10px;
    text-align: left;
}
.con1-title{
    font-weight: bold;
    font-size: 32px;
    height: 50px;
    padding-top: 2%;
    text-shadow: 0px 2px 4px #FFFFFF;
}
.con-text{
    color: #005CE5;
    font-weight: bold;
    font-size: 14px;
}
.home-bigImg{
    padding: 8% 0 22% 0;
}
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
}
.slide1 {
    background: #FFFFFF;
    color: black;
    font-size: 3rem;
    margin: 0 14px;
    border-radius: 20px;
    white-space: nowrap;
    box-shadow: 0px 0px 18px 2px rgba(0,0,0,0.1);
}
.slide2 {
    background: #FFFFFF;
    color: black;
    font-size: 3rem;
    margin: 0 14px;
    white-space: nowrap;
    height: 500px;
    box-shadow: 0px 0px 18px 2px rgba(0,0,0,0.1);
}

.swiper-pagination {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
    position: relative;
    margin-top: 15px;
}
.swiper-wrapper{
    margin-left: 0px;
    z-index:0
}
.swiper-container{
    z-index: 0;
}
.swiper-pagination1 {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
    position: relative;
    margin-top: 15px;
}
.swiper-wrapper1{
    margin-left: 0px;
    z-index:0
}
.swiper-container1{
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 0;
}
</style>
